module.exports = __webpack_public_path__ + "img/img10.d9266200.png";